module.exports = __webpack_public_path__ + "img/cervical-screening.94721c9f.jpg";